// Studio Grape theme tokens — Aubergine + Linen
export const colors = {
  bg: "#FAF9F6",
  surface: "#FFFFFF",
  surfaceSubtle: "#F4F1F2",
  brand: "#3E1837",
  brandHover: "#2B1026",
  accent: "#CBA3B5",
  ink: "#1C191B",
  muted: "#6B6568",
  line: "#E8E3E6",
  success: "#2D5A3C",
  warning: "#8E5A19",
  danger: "#8A2525",
  badgeBg: "#F4F1F2",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_grape-web-client/artifacts/s4xsql5r__%5Blogo%5D%20studio%20grape%202%20line%20square.png";
